import { useState, useEffect } from "react";

import getBlogArticles from "../api/getBlogArticles";
import ContentCard from "./contentCard";
import getBlogArticleTopics from "../helpers/getBlogArticleTopics";

const LatestBlogs = () => {
  let [blogArticles, setBlogArticles] = useState([]);
  let [blogUrl, setBlogUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const getBlogData = async () => {
    setLoading(true);
    const response = await getBlogArticles();
    setLoading(false);

    let returnedBlogArticles = response?.items ?? [];
    let blogTopics = window?.setTopics ?? getBlogArticleTopics(returnedBlogArticles);

    if (typeof blogTopics === "string") {
      blogTopics = JSON.parse(blogTopics);
    }

    returnedBlogArticles = returnedBlogArticles.filter((props) =>
      props.properties.tags.some((tags) => blogTopics.includes(tags))
    );

    const articles = returnedBlogArticles;
    setBlogArticles(articles);
  };

  // sort articles by latest date
  function sortArticles() {
    blogArticles.sort(function (a, b) {
        return new Date(b.properties.date ) - new Date(a.properties.date );
    });
}
 
sortArticles();

// take latest 2 articles
blogArticles = blogArticles.slice(0, 2);

  useEffect(() => {
    let blogUrlsqw = window?.setPageProps?.url ?? "/";
    setBlogUrl(blogUrlsqw);
    getBlogData();
  }, [blogUrl]);

  return (
    <>
      {loading ? (
        <div className="wmcads-loader wmcads-loader--small wmcads-m-l-xs"></div>
      ) : (
        <>
          {blogArticles.length ? (
            <>
            <section className="wmcads-css-grid-2-col wmcads-m-t-md wmcads-m-b-lg">
              {blogArticles?.map((blogArticle, index) => (
                <ContentCard
                  route={blogArticle.route.path}
                  key={index}
                  name={blogArticle.name}
                  id={blogArticle.id}
                  authors={blogArticle.properties.author}
                  tags={blogArticle.properties.tags}
                  image={
                    blogArticle.properties.image != null
                      ? blogArticle.properties.image[0].url
                      : "No Image"
                  }
                  imageId={
                    blogArticle.properties.image != null
                      ? blogArticle.properties.image[0].id
                      : null
                  }
                  publishDate={blogArticle.properties.date}
                  introductionText={blogArticle.properties.introduction}
                  blogroute={'#/article/' + blogArticle.route.path.replace('/blog/', '')}
                  blogurl={blogUrl}
                />
              ))}
            </section>
            <a href={blogUrl} target="_self" className="wmcads-link wmcads-m-b-lg">See all blog posts</a>
            </>
          ) : null}
        </>
      )}
    </>
  );
};

export default LatestBlogs;
